
import {TfiAngleLeft} from "react-icons/tfi";

const BillCard=({billInfo,onClick,serviceType})=>{
    const classNames={
        Water:"water",
        TelBills:"tel",
        MobileBills:"mobile",
        GasByBillId:"gas",
        Electricity:"electricity"
    }
    return  <div onClick={onClick} className={`bill-card ${classNames[billInfo.bill_type]}`}>
                    <div className="w-full flex justify-between items-center">

                        <div><strong className="title">{billInfo.alias}</strong>
                            <p className="parameter">{billInfo.bill_main_param}</p></div>
                        <div className="rounded-full  flex justify-center items-center  w-10 h-10  ">
                            <TfiAngleLeft/>
                        </div>
                    </div>
            </div>
}
export default BillCard;